// HeaderTitleSection.js
// 从 App.js 抽取出的「头部左上角 LOGO 区域」组件
// 包含：LOGO 图标（悬浮旋转动画）、主题切换按钮、绿屏模式按钮、slogan 文案
// 学单词/学用法/学句子页面统一使用同一份样式（此前学句子页少了 LOGO 的垂直位移样式，这次一并统一）

import React from 'react';

function HeaderTitleSection({
  isMobile,
  currentTheme,
  isHovering,
  setIsHovering,
  theme,
  toggleTheme,
  greenScreen,
  setGreenScreen,
  setShowQRCode,
}) {
  const titleSectionStyle = {
    width: isMobile ? '100%' : '25%',
    textAlign: isMobile ? 'center' : 'left',
    flexShrink: 0,
  };

  return (
    <div style={titleSectionStyle}>
      <h1 style={{
        fontSize: isMobile ? '1.5em' : '2em',
        margin: 0,
        wordBreak: 'break-word',
        color: currentTheme.text,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
        justifyContent: isMobile ? 'center' : 'flex-start',
        lineHeight: '1.2',
      }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>

          <img
            src="/logo.png"
            alt="削词侠 LOGO"
            style={{
              height: '1.35em',
              width: 'auto',
              animation: isHovering
                ? 'spin 1s ease-in infinite'
                : 'spinDown 2s ease-out forwards',
            }}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
          />

          削词侠
          <button
            onClick={toggleTheme}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1em',
              cursor: 'pointer',
              padding: '0',
              margin: '0',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'transform 0.3s ease',
              filter: theme === 'dark' ? 'brightness(1.2)' : 'none',
              lineHeight: '1',
              height: '1em',
              transform: 'scale(0.8) translateY(2px)',
              willChange: 'transform',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(0.96) translateY(2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(0.8) translateY(2px)';
            }}
            title={theme === 'light' ? '切换到夜间模式' : '切换到日间模式'}
            aria-label={theme === 'light' ? '切换到夜间模式' : '切换到日间模式'}
          >
            {theme === 'light' ? '☀️' : '🌙'}
          </button>

          <button
            onClick={() => {
              setGreenScreen(prev => {
                const next = !prev;
                if (next) setShowQRCode(true);
                return next;
              });
            }}
            style={{
              background: greenScreen ? 'rgba(255,255,255,0.3)' : 'none',
              border: greenScreen ? '1px solid rgba(255,255,255,0.6)' : 'none',
              fontSize: '0.85em',
              cursor: 'pointer',
              padding: '2px 6px',
              marginLeft: '4px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              color: greenScreen ? '#ffffff' : 'inherit',
              transition: 'all 0.2s',
            }}
            title={greenScreen ? '退出绿屏模式 (Ctrl+G)' : '绿屏模式 (Ctrl+G)'}
          >
            🟢
          </button>

        </span>
      </h1>

      <p style={{
        fontSize: '0.95em',
        color: currentTheme.secondaryText,
        margin: '4px 0 0',
        textAlign: isMobile ? 'center' : 'left',
        letterSpacing: '0.18em',
        paddingRight: '0.55em',
      }}>
        削掉已会 只学不会
      </p>
    </div>
  );
}

export default HeaderTitleSection;
